import type { CierreFinancieroState } from '../contexts/dataContext';

export function totalAhorros(cierreFinanciero: CierreFinancieroState): number {
    return (
        (cierreFinanciero.tiempoSeleccionado != null
            ? cierreFinanciero.cantidadPrimas * (cierreFinanciero.salarioMensual / 2) * cierreFinanciero.tiempoSeleccionado
            : 0)
        + cierreFinanciero.ahorros
        + cierreFinanciero.ahorroMensual * (cierreFinanciero.tiempoSeleccionado ?? 0) * 12
        + cierreFinanciero.cesantias
        + (cierreFinanciero.cesantiasFuturas === 'si' ? (cierreFinanciero.salarioMensual * (cierreFinanciero.tiempoSeleccionado ?? 0)) : 0)
    );
}

export function cesantiasTotalesFuturas(cierreFinanciero: CierreFinancieroState): number {
    if (cierreFinanciero.cesantiasFuturas === 'si') {
        return (cierreFinanciero.salarioMensual * (cierreFinanciero.tiempoSeleccionado ?? 0))
            + cierreFinanciero.cesantias;
    }
    return 0;
}

export function subsidioCaja(cierreFinanciero: CierreFinancieroState): number {
    // Solo si valor vivienda < 150 SMMLV y salario < 4 SMMLV
    if (
        cierreFinanciero.valorVivienda >= cierreFinanciero.valorSalarioMinimo * 150 ||
        cierreFinanciero.salarioMensual > cierreFinanciero.valorSalarioMinimo * 4
    ) return 0;
    if (cierreFinanciero.salarioMensual > 0 && cierreFinanciero.salarioMensual < cierreFinanciero.valorSalarioMinimo * 2) return 42705000;
    if (cierreFinanciero.salarioMensual >= cierreFinanciero.valorSalarioMinimo * 2 && cierreFinanciero.salarioMensual < cierreFinanciero.valorSalarioMinimo * 4) return 28470000;
    return 0;
}

export function subsidioMunicipio(cierreFinanciero: CierreFinancieroState): number {
    // Solo si valor vivienda < 150 SMMLV, salario < 4 SMMLV, compra en Medellín
    if (
        cierreFinanciero.valorVivienda >= cierreFinanciero.valorSalarioMinimo * 150 ||
        cierreFinanciero.salarioMensual >= cierreFinanciero.valorSalarioMinimo * 4 ||
        cierreFinanciero.municipioCompra !== 'MEDELLÍN - ANTIOQUIA'
    ) return 0;
    if (cierreFinanciero.subsidioCajaValue === 1) {
        return 13000000;
    } else {
        return 15000000;
    }
}
// Subsidio Gobernación
export function subsidioDepartamento(cierreFinanciero: CierreFinancieroState): number {
    // Solo si valor vivienda < 150 SMMLV, salario < 4 SMMLV, y cumple requisitos de caja o municipio
    const valorViviendaOk = cierreFinanciero.valorVivienda < cierreFinanciero.valorSalarioMinimo * 150;
    const salarioOk = cierreFinanciero.salarioMensual < cierreFinanciero.valorSalarioMinimo * 4;
    const municipioAntioquia = cierreFinanciero.municipioCompra?.includes('ANTIOQUIA');
    const recibeCaja = subsidioCaja(cierreFinanciero) > 0;
    const recibeMunicipio = subsidioMunicipio(cierreFinanciero) > 0;
    if (valorViviendaOk && salarioOk && municipioAntioquia && (recibeCaja || recibeMunicipio)) {
        return 9964500;
    }
    return 0;
}

export function sumaSubsidios(cierreFinanciero: CierreFinancieroState): number {
    // Solo si valor vivienda < 150 SMMLV y salario < 4 SMMLV
    if (
        cierreFinanciero.valorVivienda < cierreFinanciero.valorSalarioMinimo * 150 &&
        cierreFinanciero.salarioMensual < cierreFinanciero.valorSalarioMinimo * 4
    ) {
        return (
            (cierreFinanciero.subsidioCajaValue || 0) +
            (cierreFinanciero.subsidioMunicipioValue || 0) +
            (cierreFinanciero.subsidioDepartamento || 0)
        );
    }
    return 0;
}

export function valorTotalCredito(cierreFinanciero: CierreFinancieroState): number {
    const salario = Number(cierreFinanciero.salarioMensual) || 0;
    const porcentajeEndeudamiento = salario === 0 ? 0 : cierreFinanciero.pagoMensual / salario;
    const porcentajeEndeudamientoTotalMaximo = 0.40 - porcentajeEndeudamiento;
    const cuotasCreditosExistentes = Number(cierreFinanciero.creditos) || 0;
    const tasaMensual = 0.008;
    const plazoMeses = 240;

    function pago(tasa: number, n: number, pv: number) {
        if (tasa === 0) return pv / n;
        const factor = Math.pow(1 + tasa, n);
        return  Math.abs(pv * (tasa * factor) / (factor - 1));
    }

    const cuotaMaximaTotalPermitida = salario * porcentajeEndeudamientoTotalMaximo;
    let cuotaMaximaDisponibleParaNuevoCredito = cuotaMaximaTotalPermitida - cuotasCreditosExistentes;
    if (cuotaMaximaDisponibleParaNuevoCredito < 0) {
        cuotaMaximaDisponibleParaNuevoCredito = 0;
    }
    const cuotaReferencia = pago(tasaMensual, plazoMeses, -1000000);
    if (cuotaReferencia === 0 || cuotaMaximaDisponibleParaNuevoCredito === 0) {
        return 0;
    }
    const valorCredito = Math.round((cuotaMaximaDisponibleParaNuevoCredito / cuotaReferencia) * 1000000);
    if (isNaN(valorCredito)) {
        return 0;
    }
    return valorCredito;
}
